import { hosts } from 'settings';
import { memberStorage } from './memberStorage';

export const proxyCookie = $location => {
  'ngInject';

  const { hasSetCookie } = memberStorage.get();
  const isRootUrl = $location.$$url === '/';

  if (hasSetCookie && !isRootUrl) {
    return;
  } else {
    if ($location.search().cookie_set) {
      memberStorage.setKey('hasSetCookie', true);
      $location.search('cookie_set', null);
    } else {
      const uri = `${hosts.api}/proxy.html`;
      const referrer = encodeURIComponent(window.location.href);
      window.location.assign(`${uri}?set_cookie=true&referrer=${referrer}`);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/proxyCookie.js